import { useContext } from 'react';
import InteractionContext from '@atlaskit/interaction-context';
export default InteractionContext;
export function useInteractionContext() {
  return useContext(InteractionContext);
}